// extracted by mini-css-extract-plugin
export var avatar = "_sa-3";
export var avatarContainer = "_sa-2";
export var avatarSpacer = "_sa-5";
export var avatarSpacerContainer = "_sa-4";
export var avatarStackContainer = "_sa-1";
export var bubble = "_sa-0";
export var remainderBubble = "_sa-6";